"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilingModule = void 0;
const base_1 = require("./base");
const fanApp_1 = require("../fanApp");
class ProfilingModule extends base_1.SurveyModule {
    constructor(_a) {
        var { index, force } = _a, rest = __rest(_a, ["index", "force"]);
        super(rest);
        this._type = "profiling";
        this._index = index;
        this._force = force;
    }
    get index() {
        return this._index;
    }
    set index(index) {
        if (index < 0) {
            throw new Error("index must be greater than or equal to 0");
        }
        this.index = index;
    }
    get force() {
        return this._force;
    }
    set force(force) {
        if (!!force && !fanApp_1.DEFAULT_PROFILING_CATEGORIES.includes(force)) {
            throw new Error(`${force} is not a valid profile category`);
        }
        this.force = force;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const baseModule = {
                index: this.index,
                type: this.type,
            };
            if (this.force) {
                baseModule.force = this.force;
            }
            return baseModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        return this.toBuilderConfig();
    }
    editProps() {
        return undefined;
    }
}
exports.ProfilingModule = ProfilingModule;
//# sourceMappingURL=Profiling.js.map